import { render, staticRenderFns } from "./FormularioCultura.vue?vue&type=template&id=b7f30104&scoped=true&"
import script from "./FormularioCultura.vue?vue&type=script&lang=ts&"
export * from "./FormularioCultura.vue?vue&type=script&lang=ts&"
import style0 from "./FormularioCultura.vue?vue&type=style&index=0&id=b7f30104&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f30104",
  null
  
)

export default component.exports